import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import ApiService from "../../services/ApiService";
import { ATHLETE, ENGAGEMENT_VALUE_PERIOD } from "../keys";
import { format } from "date-fns";

const useEngagementValuePeriod = () => {
  const tenant = useSelector((state) => state.auth.tenant);
  const date = useSelector((state) => state.date);

  const { startDate, endDate } = date;
  const enabled = !!(date.startDate && date.endDate);
  let since;
  let until;
  if (enabled) {
    since = format(date.startDate, "yyyy-MM-dd");
    until = format(date.endDate, "yyyy-MM-dd");
  }

  return useQuery({
    queryKey: [ATHLETE, ENGAGEMENT_VALUE_PERIOD, tenant.id, startDate, endDate],
    queryFn: () => ApiService.getEngagementValuePeriod(since, until),
    select: (data) => JSON.parse(JSON.stringify(data.data.graphs)),
    placeholderData: { data: { graphs: [] } },
  });
};
export default useEngagementValuePeriod;
